const canToggleMark = (editor, markName, markValue = true) => {
  return editor.canToggleMarks({ [markName]: markValue });
};
export {
  canToggleMark
};
//# sourceMappingURL=canToggleMark.js.map
